import {Component, Input, OnInit} from '@angular/core';
import {DialogService} from "@rbaip/ui-component";
import {ItemSummaryItemService} from "../../shared/asset/item-summary-item.service";
import {Asset} from "../../shared/domain/item";

@Component({
  selector: 'lib-mark-asset-as-reviewed',
  templateUrl: './mark-asset-as-reviewed.component.html'
})
export class MarkAssetAsReviewedComponent implements OnInit {

  @Input() equipId: number;
  @Input() asset: Asset;
  @Input() itemService: ItemSummaryItemService;
  equipList: number[]=[];

  constructor(private dialogService: DialogService) {
  }

  ngOnInit(): void {
  }

  markAssetReviewed(): void{
    this.equipList.push(this.equipId);
    this.dialogService.showProgress();
    this.itemService.markAsReviewed(this.equipList).subscribe(response =>{
      this.dialogService.hideProgress();
      this.dialogService.showMessage("Successfully Marked Asset as reviewed");
    })

  }


}
